<template>
  <div class="outer-wrapper">
      <div class="title">
        <p>合同执行单</p>
    </div>
    <Tabs>
      <TabPane label="现有合同执行单" icon="logo-buffer">
        <report-list
          :columnsFormatData="reportAlready"
          askData="orderPaperAlready"
          :refreshData="update_count"
          main_width="1280px"
        ></report-list>
      </TabPane>
      <Button @click="doReport()" slot="extra" type="primary">新建合同执行单</Button>
    </Tabs>
  </div>
</template>
<script>
import reportList from "@/components/Common/ReportList.vue";
let authData = JSON.parse(localStorage.getItem("authData"));
let userToken = localStorage.getItem("current_user_token");
//import shellExpand from "./ShellExpand.vue";

function itemValue(){
    return {
        pronumRange:"",
        reportDate:null,
        remark:''
    };
}

export default {
  name: "heatReport",
  props: [],
  components: {
    reportList,
  },
  data() {
    return {
      op_name: this.$options.name,
      update_count: 0,
      modalValue:{
          confirm:false,
      },
      item:itemValue(),
      reportAlready:[
        /*{
            type: 'expand',
            width: 30,
            render: (h, params) => {
                return h(shellExpand, {
                    props: {
                        row: params.row
                    }
                })
            }
        },*/
      
        {
          title: "合同单编号",
          key: "display_no",
          align: "center",
          render: (h, params) => {
            return h(
                "p",
                {
                  
                },
                JSON.parse(params.row.value).reportNo
              );
          }
        },
        {
          title: "下单日期",
          key: "orderDate",
          width: 150,
          align: "center",
          render: (h, params) => {
            return h(
                "p",
                {
                  
                },
                JSON.parse(params.row.value).orderDate
              );
          }
        },
        {
          title: "文件",
          align: "center",
          width: 200,
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "green",marginRight:'5px' },
                  on: {
                    click: () => {
                      window.open('/archive/heatReport/'+params.row.id,"_blank");
                    }
                  }
                },
                "查看"
              ),
              h(
                "Button",
                {
                  props: {
                    size: "small"
                  },
                  style: { color: "red" },
                  on: {
                    click: () => {
                      this.confirmBox(params.row);
                    }
                  }
                },
                "删除"
              )
            ]);
          }
        }
        
      ]
    };
  },
  computed:{

  },
  methods: {
    linkTo(url) {
      window.open(this.$fileUrlFac(url, authData.sfileRight));
    },
    openModal(value){
        this.modalValue[value] = true;
    },
    closeModal(value){
        this.modalValue[value] = false;
    },
    confirmBox(value) {
      this.$Modal.confirm({
        title: "确认删除：",
        content:
          "<p>" +
          "报告：" +
          value.display_no +          
          "</p>"+"<p>" +
          "工件编号：" +
          value.pronumRange +          
          "</p>",
        onOk: () => {
          this.recordFormatDel(value.id);
        },
        onCancel: () => {}
      });
    },
    recordFormatDel(id) {
      this.$axios
        .post(this.$url + "/report", {
          userToken: userToken,
          askData: "delReport",
          id: id
        })
        .then(response => {
          if (response.data.stat === "ok") {
            this.$Message.success("删除成功！");
            this.update_count++;
          }
        })
        .catch(error => {
          this.$Message.warning(error + "网络错误！操作失败。");
        });
    },
    doReport(){
      this.$axios
        .post(this.$url + "/report", {
          userToken: userToken,
          askData: "orderCreate",
          item: this.item
        })
        .then(response => {
          if (response.data.stat == "ok") {
             window.open('/archive/orderPaper/'+response.data.fid,"_blank");
            this.closeModal("confirm");
            this.update_count++;
          } else {
            this.closeModal('confirm');
            this.$Message.error(response.data.data.info);
          }
        }).catch(error=>{
            this.$Message.error("网络连接有误！"+error);
        });
    }
  }
};
</script>
<style scoped>
.outer-wrapper{
    width:1280px;
    margin:0 auto;
}
.title{
  text-align: center;
  margin:10px auto;
  font-size:20px;

}
.cr-form{
    width:100%;
    border-collapse: collapse;
}

.cr-form td{
    height:45px;
}

.cr-form td:first-child{
    text-align: right;
}

.cr-form input{
    padding: 0 10px;
    outline: none;
    height:30px;
    border-radius: 2px;
    border:1px solid #aaa;
}
</style>